/* Collection adhesive cards — A/B variant B (Fuel_06).
   1. Attribute pill fit: every pill in a grid shares one layout and one type
      size so all cards look identical (see collection-adhesive-specs.css).
      Measures the real values and picks:
        - "one" row (desktop design) if the longest product fits at >= 13px,
        - otherwise two rows (mobile design),
        - "stack" only if two rows don't fit at 11px,
      with --adhesive-specs-font = 14px, or the largest size the longest
      product fits at. Re-run by ResizeObserver, which also fires when
      Intelligems reveals the pills (display:none -> flex) and on resize.
   2. Add to Cart: upgrades the native /cart/add form to the theme's own flow
      (assets/theme.js product form): POST /cart/add.js, read /cart.js,
      refresh the drawer via window.wetheme and open it. Falls back to the
      native form post if the theme API is unavailable. */
(function () {
  'use strict';

  var PILL_SELECTOR = '[data-adhesive-card-specs]';
  var DESIGN_FONT = 14;
  var MIN_ONE_ROW_FONT = 13;
  var MIN_FONT = 11;
  var DIVIDER = 0.6;
  var SAFETY = 0.5;

  // Width budget of one pill, split into parts that scale with font size
  // (text, per px of font) and parts that don't (icons, gaps, dividers).
  function measurePill(pill) {
    var style = getComputedStyle(pill);
    var font = parseFloat(style.fontSize);
    var gap = parseFloat(style.columnGap) || 0;
    var available = pill.clientWidth - parseFloat(style.paddingLeft) - parseFloat(style.paddingRight) - SAFETY;
    var items = Array.prototype.map.call(pill.querySelectorAll('.adhesive-card-specs__item'), function (item) {
      var icon = item.querySelector('.adhesive-card-specs__icon');
      var value = item.querySelector('.adhesive-card-specs__value');
      return {
        fixed: icon.getBoundingClientRect().width + (parseFloat(getComputedStyle(item).columnGap) || 0),
        perPx: value.getBoundingClientRect().width / font,
      };
    });
    if (items.length < 3) return null;

    function fit(parts, separators) {
      var fixed = separators * (2 * gap + DIVIDER);
      var perPx = 0;
      parts.forEach(function (part) {
        fixed += part.fixed;
        perPx += part.perPx;
      });
      return (available - fixed) / perPx;
    }

    return {
      one: fit(items, 2),
      two: Math.min(fit(items.slice(0, 2), 1), fit(items.slice(2), 0)),
      stack: Math.min(fit([items[0]], 0), fit([items[1]], 0), fit([items[2]], 0)),
    };
  }

  function fitGroup(container, pills) {
    var visible = pills.filter(function (pill) {
      return pill.clientWidth > 0;
    });
    if (!visible.length) return;

    var limits = { one: Infinity, two: Infinity, stack: Infinity };
    visible.forEach(function (pill) {
      var result = measurePill(pill);
      if (!result) return;
      limits.one = Math.min(limits.one, result.one);
      limits.two = Math.min(limits.two, result.two);
      limits.stack = Math.min(limits.stack, result.stack);
    });

    var layout = 'stack';
    var font = limits.stack;
    if (limits.one >= MIN_ONE_ROW_FONT) {
      layout = 'one';
      font = limits.one;
    } else if (limits.two >= MIN_FONT) {
      layout = 'two';
      font = limits.two;
    }
    font = Math.max(MIN_FONT, Math.min(DESIGN_FONT, Math.floor(font * 10) / 10)) + 'px';

    if (container.dataset.adhesiveSpecsLayout !== layout) {
      container.dataset.adhesiveSpecsLayout = layout;
    }
    if (container.style.getPropertyValue('--adhesive-specs-font') !== font) {
      container.style.setProperty('--adhesive-specs-font', font);
    }
  }

  function initPills() {
    var pills = Array.prototype.slice.call(document.querySelectorAll(PILL_SELECTOR));
    if (!pills.length || !('ResizeObserver' in window)) return;

    var groups = new Map();
    pills.forEach(function (pill) {
      var container = pill.closest('.product-grid') || document.documentElement;
      if (!groups.has(container)) groups.set(container, []);
      groups.get(container).push(pill);
    });

    function fitAll() {
      groups.forEach(function (groupPills, container) {
        fitGroup(container, groupPills);
      });
    }

    var timer = null;
    // Defer so layout changes happen outside the observer callback (avoids
    // "ResizeObserver loop" errors).
    var observer = new ResizeObserver(function () {
      if (timer) return;
      timer = setTimeout(function () {
        timer = null;
        fitAll();
      }, 0);
    });

    pills.forEach(function (pill) {
      observer.observe(pill);
    });

    if (document.fonts && document.fonts.ready) {
      document.fonts.ready.then(fitAll);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initPills);
  } else {
    initPills();
  }

  var FORM_SELECTOR = '[data-adhesive-card-atc]';

  // Spinner is drawn by CSS (.is-loading); the label stays in place so the
  // button keeps its size and accessible name.
  function setLoading(button, loading) {
    button.disabled = loading;
    button.classList.toggle('is-loading', loading);
    if (loading) {
      button.setAttribute('aria-busy', 'true');
    } else {
      button.removeAttribute('aria-busy');
    }
  }

  function clearError(form) {
    var existing = form.querySelector('.adhesive-card-atc__error');
    if (existing) existing.remove();
  }

  function showError(form, text) {
    clearError(form);
    var error = document.createElement('p');
    error.className = 'adhesive-card-atc__error';
    error.setAttribute('role', 'alert');
    error.textContent = text;
    form.appendChild(error);
  }

  function openDrawer() {
    var status = document.querySelector('.js-cart-drawer-status');
    var top = document.querySelector('.cart-drawer__top');
    if (status && top) {
      status.textContent = 'Item added to your cart';
      top.appendChild(status);
    }
    window.jQuery('#cartSlideoutWrapper').trigger('cart:open');
  }

  document.addEventListener('submit', function (event) {
    var form = event.target.closest(FORM_SELECTOR);
    if (!form) return;

    var theme = window.wetheme;
    if (!theme || typeof theme.updateCartDrawer !== 'function' || !window.jQuery || !document.getElementById('cartSlideoutWrapper')) {
      return; // Native post to /cart/add.
    }

    event.preventDefault();

    var button = form.querySelector('button[type="submit"]');
    if (!button || button.disabled) return;

    setLoading(button, true);
    clearError(form);

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { Accept: 'application/json' },
      body: new FormData(form),
    })
      .then(function (response) {
        return response.json().then(function (data) {
          if (!response.ok) {
            throw new Error(data.description || data.message || 'Unable to add to cart');
          }
          return fetch('/cart.js', { cache: 'no-store', headers: { Accept: 'application/json' } });
        });
      })
      .then(function (response) {
        return response.json();
      })
      .then(function (cart) {
        theme.updateCartDrawer(cart);
        openDrawer();
      })
      .catch(function (error) {
        showError(form, error.message);
      })
      .then(function () {
        setLoading(button, false);
      });
  });
})();
